module.exports = __webpack_public_path__ + "img/hand-paper.88f4723c.svg";